let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2x8Qv")).then(() => parcelRequire('aaxri'));